import { StateProvider, StateParams, StateService } from "@uirouter/angularjs";

import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../records/server/serverUtility";
import { vsName as ContractBookDetailGridComponentName } from "./views/info/component";
import { vsObjectName as contactBookName } from "./../ContactBook/shared/configs/contactBook";
import {
  getResolveObjectFromGridConfiguration,
  vsComponentName as RecordGridViewComponentName,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../records/views/recordGridView";

import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../records/grids/columns/columnDefinitionService";

import {
  FormViewService,
  vsComponentName as FormViewComponentName,
  vsServiceName as FormViewServiceName,
} from "../records/forms/formView";

export function routeConfig($stateProvider: StateProvider) {
  $stateProvider
    .state("main.contactBook", {
      url: "contactbook",
      template: "<ui-view></ui-view>",
      abstract: true,
      resolve: {},
    })
    .state("main.contactBook.grid", {
      url: "",
      views: {
        "@^.^": {
          component: RecordGridViewComponentName,
        },
      },
      resolve: getResolveObjectFromGridConfiguration([
        RecordGridViewServiceName,
        ColumnDefinitionServiceName,
        "$state",
        (
          recordGridViewService: RecordGridViewService,
          columnDefinitionService: ColumnDefinitionService,
          $state: StateService
        ) => {
          const config =
            recordGridViewService.getGridConfiguration(contactBookName)!;

          config.columns = columnDefinitionService.addInfoEditColumns(
            config.columns,
            {
              infoSref: "^.info",
              editSref: "^.edit",
            }
          );
          config.onAddNew = () => $state.go("^.add", {}).then(() => {});

          return config;
        },
      ]),
    })
    .state("main.contactBook.add", {
      url: "/add",
      params: {
        cloneId: undefined,
      },
      views: {
        "@^.^": {
          component: FormViewComponentName,
        },
      },
      resolve: FormViewService.getResolveObjectFromFormViewConfig(
        [
          FormViewServiceName,
          "$state",
          (formViewService: FormViewService, $state: StateService) => {
            const config = formViewService.getFormViewConfig(contactBookName)!;
            config.submitForm = (args) =>
              formViewService
                .saveForm({
                  formObject: args.model,
                  formViewController: args.formViewController,
                  url: `/api/addressBook/AddressBook`,
                })
                .then((r) => $state.go("^.info", { id: (<any>r).Result.Id }));
            return config;
          },
        ],
        [
          "$stateParams",
          ServerUtilityName,
          ($stateParams: StateParams, serverUtility: ServerUtility) => {},
        ],
        ["$state", ($state: StateService) => [() => $state.go("^.grid")]]
      ),
    })
    .state("main.contactBook.info", {
      url: "/{id:int}/info",
      component: ContractBookDetailGridComponentName,
      resolve: {
        id: [
          "$stateParams",
          function ($stateParams: StateParams) {
            return $stateParams["id"];
          },
        ],
        contactBookDetail: [
          ServerUtilityName,
          "id",
          function (serverUtility: ServerUtility, $id: number) {
            return serverUtility
              .getById({
                url: `api/addressBook/AddressBook`,
                id: $id,
              })
              .then((r: any) => r.Result);
          },
        ],
      },
    })
    .state("main.contactBook.edit", {
      url: "/{id:int}/edit",
      views: {
        "@^.^": {
          component: FormViewComponentName,
        },
      },
      resolve: FormViewService.getResolveObjectFromFormViewConfig(
        [
          FormViewServiceName,
          "$state",
          (formViewService: FormViewService, $state: StateService) => {
            const config = formViewService.getFormViewConfig(contactBookName)!;

            config.submitForm = (args: any) =>
              formViewService
                .saveForm({
                  formObject: args.model,
                  formViewController: args.formViewController,
                  url: `/api/addressBook/AddressBook/`,
                })
                .then(() => $state.go("^.info", { id: args.model.Id }));

            return config;
          },
        ],
        [
          "$stateParams",
          ServerUtilityName,
          async ($stateParams: StateParams, serverUtility: ServerUtility) => {
            const id = $stateParams["id"];

            const response = (await serverUtility.getById({
              url: `/api/addressBook/AddressBook`,
              id,
            })) as { Result: any[] };

            return response?.Result || null;
          },
        ],
        ["$state", ($state: StateService) => [() => $state.go("^.grid")]]
      ),
    });
}
routeConfig.$inject = ["$stateProvider"];
